'use strict';

var util = require('../services/tracking/blz-tracking-util');

var $smartbanner = document.querySelector('.smartbanner');
var $btnSticky = document.querySelector('.buy-button-sticky');

var Smartbanner = {
  show: function show() {
    var hasClosed = util.readCookie('smartbanner-exited');
    var blacklist = /\/minha-conta\/|webview=true/i;

    if (!hasClosed && $smartbanner && !blacklist.test(location.href)) {
      $smartbanner && $smartbanner.classList.add('bottom-up');
      $btnSticky && $btnSticky.classList.add('bottom-active');
    }
  },

  hide: function hide() {
    $smartbanner && $smartbanner.classList.remove('bottom-up');
    $btnSticky && $btnSticky.classList.remove('bottom-active');
  }
};

setTimeout(function () {
  Smartbanner.show();
}, 2000);

module.exports = Smartbanner;
